import { DinamikBilesen } from '@service/fikoyt-ui/decorators/dinamik-bilesen';
import { VardiyaNotuEditComponent } from './vardiya-notu-edit.component';
import { VardiyaNotuKartComponent } from './vardiya-notu-kart.component';

@DinamikBilesen({
  id: 'vardiya-notu',
  baslik: 'Vardiya Notu',
  aciklama: 'Vardiya notu ekle',
  ikon: 'message',
  kategori: 'uretim',
})
class VardiyaNotu {
  paylas_kutusu = VardiyaNotuEditComponent;
  paylasilmis_kart = VardiyaNotuKartComponent;
}
